export enum GoogleAnalyticsEventsEnum {
    ApiToMarketingStart = 'API to Marketing on Start',
    ApiToMarketingMenu = 'API to Marketing on Menu',
    ApiToMarketingUpseling = 'API to Marketing on Upselling',
}
